import { useRecoilValue } from 'recoil'
import { IProject } from '../projects.types'
import eventsSelectors from 'screens/Admin/Events/events.selectors'
import projectsUtils from '../projects.utils'

const useIsProjectActive = (project: Pick<IProject, 'id' | 'eventId'>) => {
  const eventsMap = useRecoilValue(eventsSelectors.eventsFullMap)
  return projectsUtils.isActiveProject(project, eventsMap)
}

export default useIsProjectActive
